import _ from "lodash";
import client from "lib/apolloClient/client";

import {
  MESSAGING_FILTER_PREFERENCE_CONFIG,
  MESSAGING_FILTER_PREFERENCE_CONFIG_ID,
} from "MessagingV2/modules/Utils";
import { getUserId, getOrganizationId } from "modules/CommonSelectors";

import { bulkUpdateConfigurationMutation } from "./ThreadListMutations";
import { generateConfigurationQueryVariablesMemoized } from "ChildrenPage/modules/ChildrenPageUtils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import {
  getPreferencesFromCacheV2,
  writePreferencesToCacheV2,
} from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";

const updateConfigValue = (data, targetConfigName, newValue) => {
  return _.map(data, group => {
    if (_.some(group.configurations, { configuration: targetConfigName })) {
      const updatedConfigurations = _.map(group.configurations, config =>
        config.configuration === targetConfigName
          ? { ...config, value: newValue }
          : config
      );

      return {
        ...group,
        configurations: updatedConfigurations,
      };
    }

    return group;
  });
};

export const onFilterPreferenceChange = ({ filterPreference }) => {
  return async (dispatch, getState) => {
    const state = getState();

    const variables = {
      src: "ORGANIZATION_LEVEL",
      organizationId: getOrganizationId(state),
      configurations: [MESSAGING_FILTER_PREFERENCE_CONFIG],
    };

    const configurationQueryVariables = generateConfigurationQueryVariablesMemoized(
      variables
    );

    const oldConfiguration = getPreferencesFromCacheV2(
      configurationQueryVariables
    );
    const oldData = {
      platform: {
        __typename: "PlatformQuery",
        configuration: oldConfiguration,
      },
    };

    const updatedConfigurations = _.map(
      _.get(oldConfiguration, "0.configurations", []),
      config => {
        if (config.configuration === MESSAGING_FILTER_PREFERENCE_CONFIG) {
          return {
            ...config,
            value: JSON.stringify(filterPreference),
          };
        }
        return config;
      }
    );

    const newData = {
      platform: {
        __typename: "PlatformQuery",
        preferences: [
          {
            configurations: updatedConfigurations,
            __typename: "ConfigurationResponse",
          },
        ],
      },
    };

    try {
      writePreferencesToCacheV2(configurationQueryVariables, newData);
      await client.mutate({
        mutation: bulkUpdateConfigurationMutation,
        variables: {
          input: [
            {
              id: MESSAGING_FILTER_PREFERENCE_CONFIG_ID,
              valueType: "JSON",
              entityGroups: [
                [
                  {
                    entityId: getUserId(),
                    entityType: "USER",
                  },
                ],
              ],
              value: JSON.stringify(filterPreference),
            },
          ],
          portalType: "PLANNER",
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            setMultipleConfigurationValueForEntityGroups: true,
            __typename: "PlatformMutations",
          },
        },
      });
    } catch (err) {
      writePreferencesToCacheV2(configurationQueryVariables, oldData);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return {};
    }
  };
};
